export const locale = {
    lang: 'en',
    data: {
        NAV: {
            APPLICATIONS: 'Aplicações',
            MODULES: 'Módulos',
            PAINEL        : {
                TITLE: 'Painel',
            },
            CARGA        : {
                TITLE: 'Carga de Documentos',
            },
            ADMIN        : {
                TITLE: 'Administrador',
            },
            SUPERADMIN        : {
                TITLE: 'SuperAdmin',
            },
            COORDENADOR  : {
                TITLE: 'Coordenador',
            },
            ARQUIVISTA        : {
                TITLE: 'Arquivista',
            },
            TAREFA        : {
                TITLE: 'Tarefas',
                ADMINISTRATIVAS: {
                    TITLE: 'Administrativo'  // ALTERADO PELA PGE-RS
                }
            },
            PROTOCOLO        : {
                TITLE: 'Protocolo',
                ADMINISTRATIVO: {
                    TITLE: 'Administrativo'
                },
            },
            PESQUISA        : {
                TITLE: 'Pesquisa'
            },
            RELATORIOS        : {
                TITLE: 'Relatórios'
            },
            RELATORIO        : {
                TITLE: 'SUPP'
            },
            OFICIO : {
                TITLE: 'Ofícios'
            },
            PROTOCOLO_EXTERNO : {
                TITLE: 'Protocolo'
            },
            CAIXA_EMAIL: {
                TITLE: 'Caixa de E-mail'
            }, // ALTERADO PELA PGE-RS
            BD0 : {
                TITLE: 'SUPP BD-0'
            },
            NUPS_POR_NUCLEO : {
                TITLE: 'NUPs do Setor Principal/Núcleo'
            },
            ADVOGADOS : {
                TITLE: 'Advogados'
            },
        }
    }
};
